import { config } from 'CONFIG';
import store from '@/store';
import { isMobile } from '@/common/js/utils';

// 根据UA和语言返回对应的官网url
export function getOfficialUrl( url: string  = '//' ): string {

    if ( url.includes( 'www.uniden.com' )) {

        return url;

    }

    /** camovue 版本会有reolink的链接，不进行替换*/
    if ( config.oem === 'snapeak' && url.includes( 'reolink' )) {

        return url;

    }

    const { reolink, isProduction } = config;
    const pre = reolink.includes( 'https://www.' ) ? 'https://www.' : 'https://';
    const root = reolink.replace( pre, '' );
    const pathWrap = url.split( '//' )[1];
    const index = pathWrap.indexOf( '/' );
    
    const countryState = store.getters.country;
    const country = countryState !== 'other' ? `${countryState}` : '';

    if ( index === -1 ) {

        return `${reolink}/${country}`;
    
    }
    const path = pathWrap.substring( index + 1 );
    const isMFlag = isMobile() ? 'm.' : ( isProduction ? '' : 'www.' );

    return `https://${isMFlag}${root}/${country}/${path}`;

}

export function getRedirectUrl( targetUrl?: string ): string {

    return encodeURIComponent( window.location.origin + ( targetUrl ?? window.location.pathname ) + window.location.search );

}
